import { FlowSpec } from '@digibee/flow';
import { create } from 'zustand';

import { LevelPathItem } from '~/scenes/Build/scenes/FlowBuilder/stores/canvasStore';

const DEFAULT_LEVEL_PATH: LevelPathItem[] = [{ label: 'root', type: 'start' }];
const DEFAULT_LEVEL_NAME = 'start';

interface DebugModeState {
  debugFlow: FlowSpec | null;
  debuggerCurrentLevelName: string;
  debuggerCurrentLevelPath: LevelPathItem[];
  isDebugMode: boolean;
}

interface DebugModeActions {
  setDebugFlow: (flowSpec: FlowSpec) => void;
  setDebuggerCurrentLevel: (
    levelPath: LevelPathItem[],
    levelName: string
  ) => void;
  setIsDebugMode: (isDebugMode: boolean) => void;
  reset: () => void;
}

export type DebugModeStore = DebugModeState & DebugModeActions;

const initialState: DebugModeState = {
  debugFlow: null,
  debuggerCurrentLevelName: DEFAULT_LEVEL_NAME,
  debuggerCurrentLevelPath: DEFAULT_LEVEL_PATH,
  isDebugMode: false
};

export const useDebugModeStore = create<DebugModeStore>()(set => ({
  ...initialState,

  setDebugFlow: flowSpec => set({ debugFlow: flowSpec }),

  setDebuggerCurrentLevel: (levelPath, levelName) =>
    set({
      debuggerCurrentLevelPath: levelPath,
      debuggerCurrentLevelName: levelName
    }),

  setIsDebugMode: isDebugMode => set({ isDebugMode }),

  reset: () => set(initialState)
}));
